module.exports = __webpack_public_path__ + "static/media/stripe-banner.50cab566.png";